module.exports = __webpack_public_path__ + "assets/TB_Android_Large_Cross_Icon.svg";